import { render, staticRenderFns } from "./TriggerSerie.vue?vue&type=template&id=a8933bd6&"
import script from "./TriggerSerie.vue?vue&type=script&lang=js&"
export * from "./TriggerSerie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports